/*
 * Vehicle Finder — Make -> Model -> Year (single year).
 * Data: static JSON asset via [data-src]; each record is {make, model, ys, ye, handle}
 * where ys/ye are the start/end years of that fitment range and handle is its key.
 * The Year dropdown lists individual years (union of all ranges for the model), and
 * picking a year matches every range that covers it — so overlapping supplier ranges
 * collapse into one clean list. On submit it filters the collection by ALL matching
 * keys (OR), and saves them to the garage for the "Fits your vehicle" badge.
 */
(function () {
  'use strict';

  function uniqSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function setup(root, vehicles) {
    var selMake = root.querySelector('[data-vf="make"]');
    var selModel = root.querySelector('[data-vf="model"]');
    var selYear = root.querySelector('[data-vf="year"]');
    var button = root.querySelector('[data-vf-submit]');
    if (!selMake || !selModel || !selYear || !button) return;

    var state = { make: '', model: '', year: '' };

    function ph(field) {
      var defaults = { make: 'Selecione a marca', model: 'Selecione o modelo', year: 'Selecione o ano' };
      return root.dataset['ph' + field.charAt(0).toUpperCase() + field.slice(1)] || defaults[field];
    }
    function fill(select, values, phText) {
      select.innerHTML = '';
      var o0 = document.createElement('option'); o0.value = ''; o0.textContent = phText; select.appendChild(o0);
      values.forEach(function (val) {
        var o = document.createElement('option'); o.value = val; o.textContent = val; select.appendChild(o);
      });
    }
    function setEnabled(select, on) { select.disabled = !on; select.classList.toggle('is-disabled', !on); }

    function makes() { return uniqSorted(vehicles.map(function (v) { return v.make; })); }
    function models() {
      return uniqSorted(vehicles.filter(function (v) { return v.make === state.make; }).map(function (v) { return v.model; }));
    }
    function years() {
      var set = {};
      vehicles.forEach(function (v) {
        if (v.make === state.make && v.model === state.model) {
          for (var y = v.ys; y <= v.ye; y++) set[y] = 1;
        }
      });
      return Object.keys(set).map(Number).sort(function (a, b) { return b - a; }).map(String);
    }
    function matchingKeys() {
      var y = parseInt(state.year, 10), keys = [];
      vehicles.forEach(function (v) {
        if (v.make === state.make && v.model === state.model && v.ys <= y && y <= v.ye) {
          if (keys.indexOf(v.handle) === -1) keys.push(v.handle);
        }
      });
      return keys;
    }
    function updateButton() {
      root._keys = (state.make && state.model && state.year) ? matchingKeys() : [];
      button.disabled = root._keys.length === 0;
    }
    function rebuildYears() {
      var ys = state.model ? years() : [];
      fill(selYear, ys, ph('year'));
      setEnabled(selYear, !!state.model && ys.length > 0);
      if (ys.indexOf(state.year) === -1) state.year = '';
      selYear.value = state.year;
      updateButton();
    }
    function rebuildModels() {
      var ms = state.make ? models() : [];
      fill(selModel, ms, ph('model'));
      setEnabled(selModel, !!state.make && ms.length > 0);
      if (ms.indexOf(state.model) === -1) state.model = '';
      selModel.value = state.model;
      rebuildYears();
    }

    fill(selMake, makes(), ph('make'));
    selMake.addEventListener('change', function () { state.make = this.value; state.model = ''; state.year = ''; rebuildModels(); });
    selModel.addEventListener('change', function () { state.model = this.value; state.year = ''; rebuildYears(); });
    selYear.addEventListener('change', function () { state.year = this.value; updateButton(); });

    button.addEventListener('click', function () {
      var keys = root._keys || [];
      if (!keys.length) return;
      if (window.VehicleGarage) {
        window.VehicleGarage.set({ make: state.make, model: state.model, year: state.year, slug: keys[0], keys: keys });
      }
      var results = root.dataset.vfResults || '/collections/all';
      var fk = root.dataset.vfFilter || 'filter.p.m.custom.fitment_handles';
      var params = keys.map(function (k) { return fk + '=' + encodeURIComponent(k); }).join('&');
      results += (results.indexOf('?') > -1 ? '&' : '?') + params;
      window.location.href = results;
    });

    // pre-fill from a saved garage vehicle
    if (window.VehicleGarage) {
      var saved = window.VehicleGarage.get();
      if (saved && saved.make && makes().indexOf(saved.make) !== -1) {
        state.make = saved.make; selMake.value = saved.make; rebuildModels();
        if (saved.model && models().indexOf(saved.model) !== -1) {
          state.model = saved.model; selModel.value = saved.model; rebuildYears();
          if (saved.year && years().indexOf(String(saved.year)) !== -1) {
            state.year = String(saved.year); selYear.value = state.year; updateButton();
          }
        }
      }
    }
  }

  function readEmbedded(root) {
    var el = document.getElementById(root.dataset.dataId);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function init(root) {
    if (!root || root.dataset.vfInit === 'true') return;
    root.dataset.vfInit = 'true';
    var src = root.dataset.src;
    if (src && window.fetch) {
      fetch(src, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { setup(root, Array.isArray(data) ? data : (data.vehicles || [])); })
        .catch(function () { setup(root, readEmbedded(root)); });
    } else {
      setup(root, readEmbedded(root));
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-vehicle-finder]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
